export enum SurfaceType {
    Compose = 0,
    Hover = 1,
    Read = 2,
}
